<template>
  <div class="flex-container">
    <div class="flex-item" data-aos="slide-up">
      <div class="flex-icon">
        <i class="fa-solid fa-code"></i>
      </div>
      <h2>Header templates</h2>
    </div>
    <div class="flex-item" data-aos="slide-up">
      <div class="flex-icon">
        <i class="fa-solid fa-pen"></i>
      </div>
      <h2>Footer templates</h2>
    </div>
    <div class="flex-item" data-aos="slide-up">
      <div class="flex-icon">
        <i class="fa-solid fa-book"></i>
      </div>
      <h2>E-commerce templates</h2>
    </div>
    <div
      class="flex-item"
      data-aos="slide-up"
      @click="$router.push('/templates/landing-pages')"
    >
      <div class="flex-icon">
        <i class="fa-solid fa-coins"></i>
      </div>
      <h2>Landing pages</h2>
    </div>
    <div class="flex-item" data-aos="slide-up">
      <div class="flex-icon">
        <i class="fa-solid fa-house"></i>
      </div>
      <h2>forms</h2>
    </div>
    <div class="flex-item" data-aos="slide-up">
      <div class="flex-icon">
        <i class="fa-solid fa-code"></i>
      </div>
      <h2>Menu templates</h2>
    </div>
  </div>
</template>